import React from 'react';
import { Modal as ReactstrapModal } from 'reactstrap';
import styles from './modalstyles.module.scss';
import Proptypes from 'prop-types';

const Modal = ({ wrapClassName, openModal, toggle, containerClass, children, ...props }) => {
  return (
    <ReactstrapModal
      isOpen={openModal}
      toggle={toggle}
      centered
      fullscreen="sm"
      contentClassName={styles['modal_content']}
      className={containerClass ? containerClass : styles['container']}
      wrapClassName={wrapClassName ? wrapClassName : styles['modal_wrapper']}
      {...props}
    >
      {children}
    </ReactstrapModal>
  );
};

Modal.propTypes = {
  children: Proptypes.node,
  openModal: Proptypes.bool,
  containerClass: Proptypes.string,
  wrapClassName: Proptypes.string,
  toggle: Proptypes.func,
};

export default Modal;
